import React from 'react';
import { Link } from "react-router-dom";
import { Hero, Banner, RoomContainer } from './../components';

export default function Rooms() {
  return (
    <>
      <Hero hero="roomsHero">
        <Banner title="our rooms">
          <Link to="" className="btn-primary">
            return home
        </Link>
        </Banner>
      </Hero>
      <RoomContainer />
    </>
  );
}
